import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { useAuthLoginMutation } from 'store/apis/auth.api';

interface UseAuthLoginFormManagerProps {
  next?: (data?: any) => void;
}

export const useAuthLoginFormManager = ({ next = () => {} }: UseAuthLoginFormManagerProps) => {
  const [login, { isLoading, isSuccess, isError, error }] = useAuthLoginMutation();

  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object({
    email: Yup.string().required('Email is required').email('Invalid email address'),
    password: Yup.string().required('Password is required').min(6, 'Password must be at least 6 characters'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      login(values);
    },
  });

  useEffect(() => {
    if (isError) {
      toast.error((error as any)?.data?.payload?.message);
    }

    if (!isLoading && isSuccess && !isError) {
      next();
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading_submit: isLoading,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading_submit: boolean;
    },
  ];
};
